'use client';

import {COOKIE_YM_UID, getCookie} from '@utils/cookies';
import {generateMyTrackerPixel} from '@utils/pixel';
import {useTracePathname} from '@utils/tracer/useTracePathname';
import {useSearchParams} from 'next/navigation';
import React, {PropsWithChildren, useEffect} from 'react';

import {
  enableTmrDebugging,
  logTmrEvent,
} from '@dev-landing/analytics/analytics';
import {EVENTS} from '@dev-landing/analytics/events';
import {YANDEX_METRICA_ID} from '@dev-landing/analytics/script_components/YandexMetrika';

type Props = PropsWithChildren<{
  userIp: string | null;
  deeplinkCatalogUrl: string;
  cookieDomain: string;
}>;

export const AnalyticsLayout: React.FC<Props> = ({
  children,
  userIp,
  deeplinkCatalogUrl,
  cookieDomain,
}) => {
  const searchParams = useSearchParams();

  useEffect(() => {
    if (searchParams?.get('_tmr_debug')) {
      enableTmrDebugging();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.xray.addMiddleware((t, params, gaTrackingId) => {
      if (t === 'pk-err') {
        const error = params?.rlog_message?.err;

        const err = new Error();
        err.name = 'XRAY-PK-ERR';
        err.message = `Ошибка xray-pk-err - ${error?.url}`;
      }

      return {t, params, gaTrackingId};
    });

    generateMyTrackerPixel({
      cookieDomain,
      userIp: userIp || '',
      appDeeplinkBaseUrl: deeplinkCatalogUrl,
      serviceVersion: `${process.env.APP_VERSION}`,
      emitPixelEvents: (payload) => {
        logTmrEvent({
          logEvent: EVENTS.MT_PIXEL,
          params: {
            ...payload,
            metrikaUid: getCookie(COOKIE_YM_UID) ?? '',
            pageURL: document.location.href.split('?')[0],
          },
        });

        if (window.ym) {
          window.ym(YANDEX_METRICA_ID, 'reachGoal', EVENTS.MT_PIXEL, payload);
        }
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useTracePathname();

  return <>{children}</>;
};
